import { Pipe, PipeTransform } from '@angular/core';
import { REPORT_STATUS_OPTIONS_WITH_ALL } from '../../../../shared/models/raport-generowanie';

@Pipe({
  name: 'statusLabel',
  standalone: true,
})
export class StatusLabelPipe implements PipeTransform {
  transform(status: string): string {
    return (
      REPORT_STATUS_OPTIONS_WITH_ALL.find((el) => el.value === status)?.label ??
      status
    );
  }
}
